import React from 'react';

const MessageInput = ({ handleSendMessage, message, setMessage }) => {
  const handleSubmit = (event) => {
    event.preventDefault();
    if (message.trim() !== '') { // Verifica che il messaggio non sia vuoto
      handleSendMessage({ text: message, sender: 'sent' });
      setMessage('');
    }
  };

  const handleChange = (event) => {
    setMessage(event.target.value);
  };

  return (
    <form className="message-input" onSubmit={handleSubmit}>
      <input
        type="text"
        value={message}
        onChange={handleChange}
        placeholder="Type your message..."
      />
      <button 
        type="submit"
        disabled={message.trim() === ''} // Disabilita il bottone se il messaggio è vuoto
      >
        <span className="material-symbols-rounded">
          send
        </span>
      </button>
    </form>
  );
};

export default MessageInput;
